<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormConfigSeguimiento" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="NombrePeriodo">Periodo</label>
                            <select :disabled="DisablePeriodo" @change="SetNombrePeriodo()" name="NombrePeriodo" id="NombrePeriodo" class="form-control form-select" v-model="objConfigSeguimiento.DiasPeriodo">
                                <option value="">Seleccionar</option>
                                <option v-for="(periodo, idx) in ListaPeriodos" :key="idx" :value="periodo.Dias">{{ periodo.Nombre }}</option>
                            </select>
							<CValidation v-if="this.errorvalidacion.NombrePeriodo" :Mensaje="'*'+errorvalidacion.NombrePeriodo[0]"/>
						</div>
					</div>
											
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Etapa 1</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Etapa 2</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">Etapa 3</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="disabled-tab" data-bs-toggle="tab" data-bs-target="#disabled-tab-pane" type="button" role="tab" aria-controls="disabled-tab-pane" aria-selected="false">Etapa 4</button>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                            <h6 class="mt-3">Prospecto</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label class="form-label" for="DiasEtapa1">Días entre etapas:</label>
                                    <input @input="$onlyNums($event,Etapas[0],'DiasAsignados')" type="text" v-model="Etapas[0].DiasAsignados" class="form-control" id="DiasEtapa1" placeholder="Ingresar Dias" />
                                    <CValidation v-if="this.errorvalidacion.DiasAsignados&&errorEtapa==1" :Mensaje="'*'+errorvalidacion.DiasAsignados[0]"/>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                            <h6 class="mt-3">Cotización</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label class="form-label" for="DiasEtapa2">Días entre etapas:</label>
                                    <input @input="$onlyNums($event,Etapas[1],'DiasAsignados')" type="text" v-model="Etapas[1].DiasAsignados" class="form-control" id="DiasEtapa2" placeholder="Ingresar Dias" />
                                    <CValidation v-if="this.errorvalidacion.DiasAsignados&&errorEtapa==2" :Mensaje="'*'+errorvalidacion.DiasAsignados[0]"/>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th :class="StyleTh+' text-center'">#</th>
                                                    <th :class="StyleTh" width="60%">Nombre</th>
                                                    <th :class="StyleTh" width="30%">Cant. Mínima requerida</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(detalle,index) in Etapas[1].Detalles" :key="index">
                                                    <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                    <td><h6 :class="StylePr">{{detalle.NombreAccion}}</h6></td>
                                                    <td><input @input="$onlyNums($event,detalle,'Cantidad')" type="text" :name="'CantidadAccion'+index" :id="'CantidadAccion'+index" class="form-control" v-model="detalle.Cantidad"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">
                            <h6 class="mt-3">Confirmación cotización</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label class="form-label" for="DiasEtapa3">Días entre etapas:</label>
                                    <input @input="$onlyNums($event,Etapas[2],'DiasAsignados')" type="text" v-model="Etapas[2].DiasAsignados" class="form-control" id="DiasEtapa3" placeholder="Ingresar Dias" />
                                    <CValidation v-if="this.errorvalidacion.DiasAsignados&&errorEtapa==3" :Mensaje="'*'+errorvalidacion.DiasAsignados[0]"/>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th :class="StyleTh+' text-center'">#</th>
                                                    <th :class="StyleTh" width="60%">Nombre</th>
                                                    <th :class="StyleTh" width="30%">Cant. Mínima requerida</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(detalle,index) in Etapas[2].Detalles" :key="index">
                                                    <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                    <td><h6 :class="StylePr">{{detalle.NombreAccion}}</h6></td>
                                                    <td><input @input="$onlyNums($event,detalle,'Cantidad')" type="text" :name="'CantidadAccion'+index" :id="'CantidadAccion'+index" class="form-control" v-model="detalle.Cantidad"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel" aria-labelledby="disabled-tab" tabindex="0">
                            <h6 class="mt-3">Encuesta y Facturación</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label class="form-label" for="DiasEtapa4">Días entre etapas:</label>
                                    <input @input="$onlyNums($event,Etapas[3],'DiasAsignados')" type="text" v-model="Etapas[3].DiasAsignados" class="form-control" id="DiasEtapa4" placeholder="Ingresar Dias" />
                                    <CValidation v-if="this.errorvalidacion.DiasAsignados&&errorEtapa==4" :Mensaje="'*'+errorvalidacion.DiasAsignados[0]"/>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                </div>
                            </div>
                        </div>
                    </div>

				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormConfigSeguimiento',
    props: ['poBtnSave','ListaConfiguraciones'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objConfigSeguimiento: {
				IdConfigSeguimiento: 0,
				DiasPeriodo: '',
				NombrePeriodo: '',
            },
            ListaPeriodos: [],
            // ETAPAS
            Etapas:[{
                Etapa:'1',
                DiasAsignados:'',
                Detalles:[],
            },
            {
                Etapa:'2',
                DiasAsignados:'',
                Detalles:[],
            },
            {
                Etapa:'3',
                DiasAsignados:'',
                Detalles:[],
            },
            {
                Etapa:'4',
                DiasAsignados:'',
                Detalles:[],
            }],
            DisablePeriodo:false,
            errorvalidacion: [],
            errorEtapa: 0,
			Emit: this.poBtnSave.EmitSeccion,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
			this.errorEtapa = 0;
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objConfigSeguimiento.IdConfigSeguimiento == 0) {
				await this.$http.post('configSeguimientos',
                    {...this.objConfigSeguimiento,
                        Etapas:[...this.Etapas],
                    }
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'configSeguimientos/'+this.objConfigSeguimiento.IdConfigSeguimiento,
					{...this.objConfigSeguimiento,
                        Etapas:[...this.Etapas],
                    }
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.errorEtapa = err.response.data.etapa;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        SetNombrePeriodo(){ 
            let selectedPeriodo = this.ListaPeriodos.find(periodo => periodo.Dias==this.objConfigSeguimiento.DiasPeriodo);
            this.objConfigSeguimiento.NombrePeriodo = selectedPeriodo.Nombre;
        },
        // RECUPERA LAS ACCIONES Y LOS DETALLES Y LOS JUNTA DONDE SEA LOS IDACCION COINCIDAN
        SetAccionesDetalles(){
            let EtapasCopia = JSON.parse(JSON.stringify(this.Etapas));
            this.$http.get('acciones'
            ).then((res) => {
                const ACCIONES = res.data.data.data;
                EtapasCopia[1].Detalles = [];
                EtapasCopia[2].Detalles = [];
                ACCIONES.forEach(accion => {
                    let newDetalle = {
                        IdEtapaDetalle:0,
                        IdEtapaSeguimiento:0,
                        NombreAccion:accion.Nombre,
                        Cantidad:'',
                        IdAccion:accion.IdAccion,
                    };

                    // Para Etapa 2 (Cotización)
                    let newDetEtapa2 = {...newDetalle};
                    let detalleEtapa2 = this.Etapas[1].Detalles.find(detalle => detalle.IdAccion == accion.IdAccion);
                    if (detalleEtapa2){
                    //    detalleEtapa2.NombreAccion = newDetEtapa2.NombreAccion;
                       Object.assign(newDetEtapa2, detalleEtapa2)
                    } 
                    // else {
                        EtapasCopia[1].Detalles.push(newDetEtapa2);
                    // }
                    
                    // Para Etapa 3 (Cotización y Confirmación)
                    let newDetEtapa3 = {...newDetalle};
                    let detalleEtapa3 = this.Etapas[2].Detalles.find(detalle => detalle.IdAccion == accion.IdAccion);
                    if (detalleEtapa3){
                        //    detalleEtapa3.NombreAccion = newDetEtapa3.NombreAccion;
                        Object.assign(newDetEtapa3, detalleEtapa3);
                    } 
                    // else {
                        EtapasCopia[2].Detalles.push(newDetEtapa3);
                    // }
                })
            }).finally(()=>{
                this.Etapas = EtapasCopia;
            }).catch(err => console.error(err));
        },
        SetPeriodos(){
            this.ListaPeriodos = [
                {Nombre:'1 Semana',Dias:7},
                {Nombre:'2 Semanas',Dias:14},
                {Nombre:'3 Semanas',Dias:21},
                {Nombre:'1 Mes',Dias:30},
                {Nombre:'2 Meses',Dias:60},
                {Nombre:'3 Meses',Dias:90},
                {Nombre:'4 Meses',Dias:120},
                {Nombre:'5 Meses',Dias:150},
                {Nombre:'6 Meses',Dias:180},
                {Nombre:'7 Meses',Dias:210},
                {Nombre:'8 Meses',Dias:240},
                {Nombre:'9 Meses',Dias:270},
                {Nombre:'10 Meses',Dias:300},
                {Nombre:'11 Meses',Dias:330},
                {Nombre:'12 Meses',Dias:360},
                {Nombre:'Más de 1 Año',Dias:361},
            ];

            if(!this.objConfigSeguimiento.IdConfigSeguimiento){
                this.ListaPeriodos = this.ListaPeriodos.filter(perido => {
                    return !this.ListaConfiguraciones.some(config => perido.Dias == config.DiasPeriodo);
                })
            }
        },
		Recuperar()
        {
            this.$http.get(
                "configSeguimientos/"+this.objConfigSeguimiento.IdConfigSeguimiento
            ).then((res) => {
                this.objConfigSeguimiento = res.data.data;
                this.Etapas = res.data.data.Etapas;
                this.SetAccionesDetalles();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objConfigSeguimiento = {
				IdConfigSeguimiento: 0,
				DiasPeriodo: '',
				NombrePeriodo: '',
            }
             // ETAPAS
            this.Etapas=[{
                Etapa:'1',
                DiasAsignados:'',
                Detalles:[],
            },
            {
                Etapa:'2',
                DiasAsignados:'',
                Detalles:[],
            },
            {
                Etapa:'3',
                DiasAsignados:'',
                Detalles:[],
            },
            {
                Etapa:'4',
                DiasAsignados:'',
                Detalles:[],
            }],
            this.errorEtapa = 0;
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objConfigSeguimiento.IdConfigSeguimiento = Id;
                this.DisablePeriodo=true;
                this.Recuperar();
                this.SetPeriodos();
            }
            else
            {
                this.SetPeriodos();
                this.SetAccionesDetalles();
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
